var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 21,
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.6673 8.49986C16.6673 12.6607 12.0515 16.994 10.5015 18.3324C10.3571 18.4409 10.1813 18.4996 10.0007 18.4996C9.81999 18.4996 9.64421 18.4409 9.49982 18.3324C7.94982 16.994 3.33398 12.6607 3.33398 8.49986C3.33398 6.73175 4.03636 5.03605 5.28661 3.78581C6.53685 2.53557 8.23254 1.83319 10.0007 1.83319C11.7688 1.83319 13.4645 2.53557 14.7147 3.78581C15.9649 5.03605 16.6673 6.73175 16.6673 8.49986Z",
  stroke: "black",
  strokeWidth: 1.08333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0007 10.9999C11.3814 10.9999 12.5007 9.88057 12.5007 8.49986C12.5007 7.11915 11.3814 5.99986 10.0007 5.99986C8.61994 5.99986 7.50065 7.11915 7.50065 8.49986C7.50065 9.88057 8.61994 10.9999 10.0007 10.9999Z",
  stroke: "black",
  strokeWidth: 1.08333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgIconLocation;